import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetConsumableActivities(id: string | undefined) {
  return useQuery(queries.products.getConsumableActivitiesById(id || ''))
}
